<template>
  <div class="share-per-department">
    <SharePerDepartmentModal
      v-model="showModal"
      :period-id="financialPeriodId"
      :department-name="selectedDep"
      :departments="departments"
    />

    <Chart :title="title" :currency="settings.currency">
      <template #chart>
        <HighChart v-if="chartData" :options="mergedChartData" />
      </template>
      <template #widget-options>
        <div class="actions-wrapper">
          <YearSelect v-model="financialPeriodId" />
          <slot name="widget-options" />
        </div>
      </template>
    </Chart>
  </div>
</template>

<script>
import * as apiTo from '../../../api'
import { customChartData } from './custom-chart-data'
// Libraries
import { merge, capitalize } from 'lodash'
// Components
import { Chart as HighChart } from 'highcharts-vue'
import Chart from '../Chart'
import SharePerDepartmentModal from './SharePerDepartmentModal'
import YearSelect from '@/modules/financial/shared/YearSelect'

export default {
  components: {
    Chart,
    HighChart,
    SharePerDepartmentModal,
    YearSelect
  },

  props: {
    title: String
  },

  data() {
    return {
      chartData: null,
      financialPeriodId: null,
      selectedDep: null,
      departments: [],
      showModal: false
    }
  },

  computed: {
    mergedChartData() {
      if (!this.chartData) return
      return merge(this.chartData.chart, this.customChartData)
    }
  },

  watch: {
    financialPeriodId: 'getChartData'
  },

  created() {
    this.customChartData = customChartData.call(this)
    this.selectedYear = new Date().getFullYear()
  },

  methods: {
    getChartData(periodId) {
      apiTo.getChartDataForFinancialPeriod(periodId, 'share-per-department').then(({ data }) => {
        this.chartData = data.result
        this.departments = data.result.chart.series[0].data
          .filter(dep => dep.y)
          .map((dep, index) => ({
            id: index + 1,
            label: capitalize(dep.name),
            value: dep.name
          }))
      })
    },

    openChartModal(depName) {
      this.selectedDep = depName
      this.showModal = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.share-per-department {
  .actions-wrapper {
    display flex
    align-items center
    justify-content flex-end
  }
}
</style>
